import { DefaultButton, PrimaryButton } from '@fluentui/react';
import { Flex } from '@fluentui/react-northstar';
import { IStackTokens, Stack } from 'office-ui-fabric-react/lib/Stack';
import * as React from 'react';
import { connect, useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { useTypedSelector } from '../../store';
import { ApplicationState } from '../../store/appThunkAction';
import { getBookmarks } from '../../store/Bookmark/actions';
import { addFilesToMeeting, addToMeeting, inMeetingSearch } from '../../store/Meeting/actions';
import SearchContentInMeeting from '../SearchInMeeting';
import styles from './index.module.scss';

const InMeetingSearch = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const stackTokens: Partial<IStackTokens> = { childrenGap: 20 };

    const {
        currentMeeting,
        selectedFiles,
        currentBookmarkSelection,
        adding
    } = useTypedSelector((state: ApplicationState) => state.meeting);

    React.useEffect(() => {
        dispatch(getBookmarks());
    }, []);

    React.useEffect(() => {

    }, [currentMeeting]);

    React.useEffect(() => {

    }, [selectedFiles]);

    const horizontalGapStackTokens: IStackTokens = {
        childrenGap: 5
    };

    const [selectedSearchFiles, updateSelectedSearchFile] = React.useState([] as {
        fileId: number;
        storyId: number;
    }[]);   
 
    const selectedCheckedFiles = selectedFiles.filter(c => c.checked);
    const addToPersentation = () => {
        if (!adding) {
            dispatch(addFilesToMeeting(currentMeeting.id, selectedCheckedFiles.map(row => {
                return {
                    fileId: row.id,
                    storyId: row.storyId
                }
            })));
            selectedSearchFiles.forEach((item) => {
                dispatch(addToMeeting(currentMeeting.id, item.fileId, item.storyId, ''));
            });

            if (selectedSearchFiles.length > 0 || currentBookmarkSelection.length > 0) {
                var message = (selectedSearchFiles.length + currentBookmarkSelection.length) + " File(s) added to your presentation";
                selectedSearchFiles.forEach((file) => { currentBookmarkSelection.push(file.fileId) });
                dispatch(inMeetingSearch(message, currentBookmarkSelection));
            }
            else { dispatch(inMeetingSearch("",[])); }

            history.push("/inmeeting");
        }
    };

    return (
        <Stack className={styles.root} tokens={horizontalGapStackTokens}>
            <Stack tokens={stackTokens}>
                <Flex className={styles.header} gap="gap.medium">
                    <SearchContentInMeeting renderBookmarks={true} overRideListHeight={true} onSelectionChange={(data) => { updateSelectedSearchFile(data) }} />
                </Flex>
            </Stack>
            <div className={ styles.divider}/>
            <Stack className={styles.btnContent}>
                <Flex className={styles.btnGroup}>
                    <DefaultButton className={styles.btnCancel} onClick={() => { dispatch(inMeetingSearch("", [])); history.push("/inmeeting") }}>Cancel</DefaultButton>
                    {(selectedSearchFiles.length > 0 || currentBookmarkSelection.length > 0) && 
                        <PrimaryButton className={`${styles.btnAddContent} ${styles.btnAddContentEnabled}`} onClick={addToPersentation}>Add {selectedSearchFiles.length + currentBookmarkSelection.length} Files</PrimaryButton>
                    }
                    {(selectedSearchFiles.length === 0 && currentBookmarkSelection.length === 0) &&
                        <PrimaryButton className={`${styles.btnAddContent} ${styles.btnAddContentDisabled}`} disabled={true}>Add Files</PrimaryButton>
                    }
                </Flex>
            </Stack>
        </Stack>
    )
};

export default connect()(InMeetingSearch);
